import { AsyncPipe } from "@angular/common";
import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { LanguageSelectionFormFieldComponent } from "@components/language-selection-form-field/language-selection-form-field.component";
import { LanguageMap } from "@domain/user/locale/language";
import { MapLanguageNamePipe } from "@domain/user/locale/map-language-name.pipe";
import { UserLocaleService } from "@domain/user/locale/user-locale.service";
import { AutocompleteModule } from "@odx/angular/components/autocomplete";
import { IconComponent } from "@odx/angular/components/icon";
import { TooltipDirective } from "@odx/angular/components/tooltip";
import { Observable } from "rxjs";

@Component({
  selector: "app-language-selection",
  imports: [
    AsyncPipe,
    IconComponent,
    TooltipDirective,
    AutocompleteModule,
    UiKitModule,
    ReactiveFormsModule,
    LanguageSelectionFormFieldComponent,
  ],
  providers: [MapLanguageNamePipe],
  templateUrl: "./language-selection-menu.component.html",
  styleUrl: "./language-selection-menu.component.scss",
  standalone: true,
})
export class LanguageSelectionMenuComponent implements OnInit {
  @Input({ required: true }) selectedLanguage!: string;
  @Output() selectionChange: EventEmitter<string> = new EventEmitter<string>();

  protected languageSelectionForm!: FormGroup;
  protected supportedLanguages$: Observable<LanguageMap[]>;

  protected readonly tooltipLanguageSupport: string = $localize`:@@dropdown.language.supportLanguages:Nur Englisch und Deutsch werden
aktiv unterstützt. Alle anderen Sprachen wurden mit KI übersetzt und können Fehler enthalten.`;

  private formBuilder = inject(FormBuilder);
  private mapLanguageNamePipe = inject(MapLanguageNamePipe);
  private userLocaleService = inject(UserLocaleService);

  constructor() {
    this.supportedLanguages$ = this.userLocaleService.supportedLanguages$;
    this.languageSelectionForm = this.formBuilder.group({
      language: null,
    });
  }

  ngOnInit() {
    this.languageSelectionForm.patchValue({
      language: this.mapLanguageNamePipe.transform(this.selectedLanguage),
    });
  }

  selectLanguage($event: string) {
    this.selectionChange.emit($event);
  }
}
